import React, { useEffect, useState } from 'react';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';

import './CustomFields.scss';

/**
 * Redux phone number input wrapper
 * @param {*} param0
 */
const ReduxPhone = ({
    initVal = '',
    label,
    name,
    className = 'country-ph',
    meta: { touched, error, warning },
    input,
}) => {
    const [value, setValue] = useState(initVal);
    useEffect(() => {
        input && input.onChange(value);
    }, [value, input]);
    return (
        <>
            {label && <label>{label}</label>}
            <PhoneInput
                name={name}
                placeholder="Enter phone number"
                value={value}
                defaultCountry="US"
                className={
                    touched && error ? className + ' inf-error' : className
                }
                onChange={setValue}
            />
            {
                ((error && value && <span className="input-error">{error}</span>) ||
                    (warning && (
                        <span className="input-error">{warning}</span>
                    )))}
        </>
    );
};

export default ReduxPhone;
